<section class="header-interno">
    <div class="container">
        <div class="header-interno-wrapper">
            <h1 class="header-interno__title">
                {{titulo}}
            </h1>
        </div>
    </div>
</section>